import { put, call, takeLatest, takeEvery } from "redux-saga/effects";
import * as Actions from "us.collection.input-output/actions";
import * as API from "us.collection.input-output/services";
import { DocumentsManager } from "us.collection.input-output/constants/Actions";
import { $Message, $MessageBox } from "us.common/components";
const { documentsManager } = Actions;

const DocumentsManagerSagas = {
  documentCategories: {
    get: function* (action: any): any {
      const params = action?.payload.data ?? {};
      try {
        const { status, data } = yield call(
          API.documentsManager.documentCategories.get,
          params,
        );
        if (status == 200) {
          yield put(documentsManager.documentCategories.success(data));
        } else {
          yield put(documentsManager.documentCategories.fail(data));
        }
      } catch (error: any) {
        yield put(documentsManager.documentCategories.fail(error));
      }
    },
  },
  entityInfo: {
    get: function* (action: any): any {
      const params = action?.payload.data ?? {};
      try {
        const { status, data } = yield call(
          API.documentsManager.entityInfo.get,
          params,
        );

        if (status == 200) {
          yield put(documentsManager.entityInfo.success({ data, params }));
        } else {
          yield put(documentsManager.entityInfo.fail(data));
        }
      } catch (error: any) {
        yield put(documentsManager.entityInfo.fail(error));
      }
    },
  },
  caseAssignment: {
    save: function* (action: any): any {
      const params = action?.payload?.data ?? {};
      const fileList = action?.payload?.fileListToUpload ?? [];
      try {
        const { data, status } = yield call(
          API.documentsManager.caseAssignment.save,
          fileList,
          params,
        );
        const jData = JSON.parse(data);
        if (status == 200) {
          if (documentsManager.caseAssignment.success) {
            yield put(
              documentsManager.caseAssignment.success({ params, data: jData }),
            );
            $Message.success("Successfully Uploaded.");
          }
        } else {
          if (documentsManager.caseAssignment.fail) {
            yield put(documentsManager.caseAssignment.fail({}));
            $Message.error(
              jData?.errors != undefined
                ? jData?.errors[0]
                : jData?.errorMessage,
            );
          }
        }
      } catch (error: any) {
        if (documentsManager.caseAssignment.fail) {
          yield put(documentsManager.caseAssignment.fail(error));
          $Message.error(error[0]);
        }
      }
    },
  },
  assignedDocument: {
    delete: function* (action: any): any {
      const params = action?.payload?.data ?? {};
      try {
        const { status } = yield call(
          API.documentsManager.assignedDocument.delete,
          params,
        );

        if (status == 200) {
          yield put(documentsManager.assignedDocuments.success(params));
        } else {
          yield put(documentsManager.assignedDocuments.fail(new Error()));
        }
      } catch (error) {
        yield put(documentsManager.assignedDocuments.fail(new Error()));
      }
    },
  },
};

export default [
  takeLatest(
    DocumentsManager.GET_DOCUMENT_CATEGORIES,
    DocumentsManagerSagas.documentCategories.get,
  ),
  takeLatest(
    DocumentsManager.GET_ENTITY_DATA,
    DocumentsManagerSagas.entityInfo.get,
  ),
  takeEvery(
    DocumentsManager.ASSIGN_TO_CASE,
    DocumentsManagerSagas.caseAssignment.save,
  ),

  takeLatest(
    DocumentsManager.RESET_ASSIGNED_DOCUMENTS,
    DocumentsManagerSagas.assignedDocument.delete,
  ),
];
